import {
    Group,
    Text,
} from '@mantine/core';

import {TestRun} from '../types.ts';

// The step counts are all individually nullable. "Not recorded" and "zero" are
// DIFFERENT facts — a run that recorded no counts at all (an ABANDONED run
// stranded before its first step reported) must not render as "0 passed", which
// would read as a run that executed and passed nothing.
export const StepCountsSummary = ({record}: { record: TestRun }) => {

    const hasCounts = [
        record.stepsTotal,
        record.stepsPassed,
        record.stepsFailed,
        record.stepsSkipped,
    ].some(value => typeof value === 'number');

    if (!hasCounts) {
        return <Text size={'xs'} c={'dimmed'}>not recorded</Text>;
    }

    return (
        <Group gap={'xs'} wrap={'nowrap'}>
            <Text size={'xs'} c={'green'} title={'Passed'}>{record.stepsPassed ?? 0}</Text>
            <Text size={'xs'} c={'dimmed'}>/</Text>
            <Text size={'xs'} c={'red'} title={'Failed'}>{record.stepsFailed ?? 0}</Text>
            <Text size={'xs'} c={'dimmed'}>/</Text>
            <Text size={'xs'} c={'dimmed'} title={'Skipped'}>{record.stepsSkipped ?? 0}</Text>
            <Text size={'xs'} c={'dimmed'}>
                of {record.stepsTotal ?? 0}
            </Text>
        </Group>
    );
};
